import { d as defineCustomElement } from '../chunks/vidstack-Uw94Yvrg.js';
import { MediaAudioLayoutElement } from './vidstack-audio-layout-el.js';
import { MediaVideoLayoutElement } from './vidstack-video-layout-el.js';
import '../chunks/vidstack-Bf6opHxk.js';
import '../chunks/vidstack-BmHT9Hib.js';
import '../chunks/vidstack-Du-_dEIb.js';
import '../chunks/vidstack-DSCDp3Na.js';
import '../chunks/vidstack-BWm2s146.js';
import '../chunks/vidstack-D73YzvPy.js';
import '../chunks/vidstack-VrKElWm_.js';
import '../chunks/vidstack-BYKVJb7W.js';
import '../chunks/vidstack-69_0Ad1E.js';
import '../chunks/vidstack-ByTY2VS-.js';
import '../chunks/vidstack-Br3oQeuO.js';
import '../chunks/vidstack-CSaHpIQV.js';
import '../chunks/vidstack-rsZGrNIW.js';

defineCustomElement(MediaAudioLayoutElement);
defineCustomElement(MediaVideoLayoutElement);
